<template>
    <v-app>
        <navigation-drawer :value="drawer" @hideSidebar="hideSidebar"/>

        <v-app-bar app elevation="0" class="navbar">
            <v-app-bar-nav-icon class="hidden-lg-and-up" @click="showSidebar"/>

            <v-spacer/>

            <slot name="app-bar-actions">
                <user-actions/>
            </slot>
        </v-app-bar>

        <v-main>
            <toast
                v-for="notification in notifications"
                :key="notification.id"

                v-model="notification.flag"
                :type="notification.type"
                :title="notification.title"
                :message="notification.message"
                :filled="notification.filled"
                :dismissible="notification.dismissible"
                :dismissible-in="notification.dismissibleIn"
            />

            <slot />
        </v-main>
    </v-app>
</template>

<script>
import NavigationDrawer from "./DrawerLayaout/NavigationDrawer";
import UserActions from "./Menus/UserActions";
import Toast from "@/Shared/toast";
import { mapState } from "pinia";
import { toast } from "@/Store/toast";

export default {
    components: {
        Toast,
        NavigationDrawer,
        UserActions,
    },

    props: {
        auth: Object,
    },

    data() {
        return {
            drawer: !(window.innerWidth < 1264),
        };
    },

    methods: {
        hideSidebar() {
            this.drawer = false;
        },

        showSidebar() {
            this.drawer = true;
        },
    },

    computed: {
        ...mapState(toast, {
            notifications: 'visibleNotifications',
        }),
    },
};
</script>
